import { apiSlice } from './apiSlice';
import { SUPPLIES_URL } from '../constants';

export const suppliesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* -----------------------------------------------------------
       CREATE SUPPLY
    ----------------------------------------------------------- */
    createSupply: builder.mutation({
      query: (supply) => ({
        url: SUPPLIES_URL,
        method: 'POST',
        body: supply,
      }),
      invalidatesTags: ['Supplies'],
    }),

    /* -----------------------------------------------------------
       GET SUPPLY DETAILS
    ----------------------------------------------------------- */
    getSupplyDetails: builder.query({
      query: (id) => ({
        url: `${SUPPLIES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, id) => [{ type: 'Supply', id }],
    }),

    /* -----------------------------------------------------------
       GET MY SUPPLIES
    ----------------------------------------------------------- */
    getMySupplies: builder.query({
      query: () => ({
        url: `${SUPPLIES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MySupplies'],
    }),

    /* -----------------------------------------------------------
       GET ALL SUPPLIES (ADMIN)
    ----------------------------------------------------------- */
    getSupplies: builder.query({
      query: () => ({
        url: SUPPLIES_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Supplies'],
    }),

    /* -----------------------------------------------------------
       UPDATE SUPPLY STATUS → DELIVERED
    ----------------------------------------------------------- */
    deliverSupply: builder.mutation({
      query: (supplyId) => ({
        url: `${SUPPLIES_URL}/${supplyId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, supplyId) => [
        { type: 'Supply', id: supplyId },
        'Supplies',
      ],
    }),

    /* -----------------------------------------------------------
       UPDATE SUPPLY (EDIT)
    ----------------------------------------------------------- */
    updateSupply: builder.mutation({
      query: ({ supplyId, ...body }) => ({
        url: `${SUPPLIES_URL}/${supplyId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, supplyId) => [
        { type: 'Supply', id: supplyId },
        'Supplies',
      ],
    }),

    /* -----------------------------------------------------------
       UPLOAD IMAGES
    ----------------------------------------------------------- */
    uploadSupplyImages: builder.mutation({
      query: (data) => ({
        url: `/api/upload`,
        method: 'POST',
        body: data,
      }),
    }),

    /* -----------------------------------------------------------
       DELETE SUPPLY
    ----------------------------------------------------------- */
    deleteSupply: builder.mutation({
      query: (supplyId) => ({
        url: `${SUPPLIES_URL}/${supplyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Supplies'],
    }),

    /* -----------------------------------------------------------
       REPAIR SUPPLY DATABASE (ADMIN)
       Triggered from frontend
    ----------------------------------------------------------- */
    repairSupplies: builder.mutation({
      query: () => ({
        url: `${SUPPLIES_URL}/repair`,
        method: 'PUT',
      }),
      invalidatesTags: ['Supplies'],
    }),
  }),
});

export const {
  useCreateSupplyMutation,
  useGetSupplyDetailsQuery,
  useGetMySuppliesQuery,
  useGetSuppliesQuery,
  useUpdateSupplyMutation,
  useUploadSupplyImagesMutation,
  useDeliverSupplyMutation,
  useDeleteSupplyMutation,
  useRepairSuppliesMutation,
} = suppliesApiSlice;
